var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-autocomplete',{class:{ required: _vm.required },attrs:{"value":_vm.value,"items":_vm.timezones,"rules":_vm.rules,"disabled":_vm.disabled,"label":"Timezone","flat":"","placeholder":"America/Phoenix","dense":""},on:{"change":value => _vm.$emit('input', value)}})
}
var staticRenderFns = []

export { render, staticRenderFns }